import React from "react";
import { useTable } from "../../Components/useTable";

const UserProfile = () => {
  const type = "Profile Users";
  const limitPerpage = 100;
  const pageRowslinit = [100, 200, 500, 1000];
  const headCells = [
    { id: "code", numeric: false, label: "RID" },
    { id: "name", numeric: false, label: "Name" },
    { id: "picture", numeric: false, label: "Profile Picture" },
    { id: "profileuser", numeric: false, label: "Status" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default UserProfile;
